import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import servicesBanner from "../../assets/images/service-bg.jpg";
import servicesImg1 from "../../assets/images/services-img.jpeg";
import servicesImg2 from "../../assets/images/workshop.jpeg";
import ex3 from "../../assets/images/ex3.jpeg";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ConnectWithoutContactOutlinedIcon from "@mui/icons-material/ConnectWithoutContactOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Services = () => {
  return (
    <div>
      <Navbar />
      <div
        className="page-header relative z-10 bg-[#F8F8F8]  page-contact-header"
        style={{
          backgroundImage: `url(${servicesBanner})`,
        }}
      >
        <div className="overlay"></div>
        <div className="container">
          <h1 className="font-bold text-2xl mb-3 text-[#fff]">
            Why Choose Amin Grand Asia
          </h1>
          <ul className="flex gap-2">
            <Link to="/" className="text-sm text-[#fff]">
              Home
            </Link>
            <ChevronRightIcon sx={{ fontSize: "19px", color: "#fff" }} />
            <Link to="/services" className="text-sm text-[#fff]">
              Our Services
            </Link>
          </ul>
        </div>
      </div>

      <section className="pt-[4rem] pb-[4rem]">
        <div className="container">
          <div className="about-row items-start">
            <div className="about-img service-img">
              <img src={servicesImg1} alt="Services 1" />
            </div>

            <div className="about-content">
              <small className="small-text">
                <span></span> Heavy Machinery
              </small>
              <h1>
                Comprehensive Machinery Solutions for All Your Project Needs
              </h1>
              <p>
                We specialize in comprehensive machinery solutions designed to
                empower every stage of your project, from initial planning
                through to final execution. With a diverse range of equipment
                tailored for construction, agriculture, and industrial
                applications, our services are crafted to meet the specific
                needs of each client. Whether you're handling a small-scale
                operation or a large, complex project, our high-quality
                equipment and dedicated support teams are here to ensure
                seamless and effective operations.
              </p>

              <p>
                Our solutions encompass not only advanced machinery rentals and
                sales but also personalized consultations to help you select the
                right tools for your objectives, and on-site assistance to
                maximize efficiency. We prioritize safety, reliability, and
                operational ease, offering versatile machinery options to tackle
                even the most demanding tasks. Rely on our industry expertise
                and customer-focused approach to provide the equipment and
                support you need, keeping your projects on track and delivering
                outstanding results every time.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-product">
        <div className="container">
          <div className="about-row items-start">
            <div className="about-content">
              <small className="small-text">
                <span></span> Workshop & Maintenance
              </small>
              <h1>
                285,000+ sq. ft. specialized workshop facilities & 35+ mobilized
                service trucks
              </h1>
              <p>
                Amin Grand Asia is proud to operate one of the most extensive
                and experienced heavy machinery workshops in the region, serving
                a wide range of industrial needs with state-of-the-art
                facilities. Strategically located across key areas in the GCC,
                including the UAE, Saudi Arabia, and Oman, our workshops are
                fully equipped to handle any machinery maintenance and repair
                requirements swiftly and efficiently.
              </p>

              <p>
                In addition to our permanent facilities, we offer a fleet of
                over 35 mobile workshops, specially designed for rapid and
                convenient on-site breakdown and emergency response. These
                mobile units are equipped with advanced tools and staffed by
                expert technicians, ensuring minimal downtime and maximum
                productivity on your project sites. At Amin Grand Asia, we are
                committed to keeping your operations running smoothly with
                reliable, responsive, and quality-driven service at every step.
              </p>
            </div>

            <div className="about-img service-img">
              <img src={servicesImg2} alt="Service 2" />
            </div>
          </div>
        </div>
      </section>

      <section className="pt-[4rem] pb-[4rem]">
        <div className="container">
          <div className="about-row items-start">
            <div className="about-img service-img">
              <img src={ex3} alt="Services 3" />
            </div>

            <div className="about-content">
              <small className="small-text">
                <span></span> Machinery Parts & Attachments
              </small>
              <h1>
                Fast Access to Authentic Heavy Equipment Parts and Attachments
              </h1>
              <p>
                As authorized distributors for industry-leading brands Toku,
                Jisung, and Simex, we offer a comprehensive selection of
                Original Equipment Manufacturer (OEM) machinery attachments
                specifically tailored for the UAE market. Our extensive
                inventory includes essential spare parts for heavy equipment,
                covering a broad range of components from mechanical and
                electrical to hydraulic systems, ensuring optimal performance
                and longevity for your machinery. With reliable brands like
                Kato, Tadano, Sany, Sumitomo, Liebherr, Zoomlion, Terex, and
                XCMG in stock, we are dedicated to providing dependable,
                high-quality solutions for every equipment need, helping you
                maintain productivity and efficiency on any project site.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-[#F6F8FA] office-lg-box  mt-5">
        <div className="container pt-[4rem]">
          <div className="as-wrap">
            <div className="as-left">
              <div>
                <h3>
                  <HomeOutlinedIcon
                    sx={{
                      color: "#6e768c",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Head Office Address
                </h3>
                <h1>P.O. BOX 118-447 United Arab Emirates</h1>
              </div>

              <div>
                <h3>
                  <ChatOutlinedIcon
                    sx={{
                      color: "#6e768c",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Call us
                </h3>
                <h1>
                  <a href="tel:+971501501145">+(971) 50 138 1984</a>
                  <br />
                  <a href="tel:+971501501145">+(971) 50 150 1145</a>
                  <br />
                  <a href="tel:+97143236878">+(971) 4 323 6878</a>
                  <br />
                </h1>
              </div>

              <div>
                <h3>
                  <MarkEmailUnreadOutlined
                    sx={{
                      color: "#6e768c",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Email Us
                </h3>
                <h1>
                  <a href="tel:+971501501145">info@agacrane.com</a>
                </h1>
              </div>
            </div>

            <div className="as-right">
              <div>
                <h3>
                  <AccessTimeOutlinedIcon
                    sx={{
                      color: "#6e768c",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Office Hours
                </h3>
                <h1>Sat to Thu 8:00am to 6:00pm</h1>
                <h1>Sunday - Closed</h1>
              </div>

              <div>
                <h3>
                  <ConnectWithoutContactOutlinedIcon
                    sx={{
                      color: "#6e768c",
                      fontSize: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Connect with us
                </h3>

                <div className="flex gap-2">
                  <a
                    href="https://wa.me/971501501145"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsAppIcon sx={{ fontSize: "25px", color: "#0DC143" }} />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <FacebookIcon sx={{ fontSize: "25px", color: "#1773EA" }} />
                  </a>
                  <a
                    href="https://www.instagram.com/craneagacompany/profilecard/?igsh=MTE3NnYxMjkyaTNtOQ=="
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon
                      sx={{ fontSize: "25px", color: "#A632A8" }}
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon sx={{ fontSize: "25px", color: "#0273AF" }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="map-google">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3606.9228027799754!2d55.4324403!3d25.3067976!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f17438261a1%3A0xe39a512e38299a38!2sAGA%20Amin%20Grand%20Asia!5e0!3m2!1sen!2s!4v1729578623265!5m2!1sen!2s"
          width="100%"
          height="550"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Map"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
